/* eslint-disable */
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import jwtdecode from 'jwt-decode';
import { UAParser } from 'ua-parser-js';
import posthog from 'posthog-js';
import apiClient from '../../../services/apiClient';
import identifyPosthogUser from '../../../utils/posthogIdentify';
import loginServices from '../../../services/loginServices';
import courseApi from '../../../services/users/courseApi';
import trialAndStripeSubscriptionService from '../../../services/trialAndStripeSubscriptionService';
import { fetchBranding, storeBranding, getCachedBranding } from '../../../services/brandingService';
import { loginSuccess, openSubscriptionModal, setSubscribedCourses, setOpenSubscriptionModalDetails, openSnackbar, languagecodevalue, ComingFrom } from '../../../store/reducer';
import { getCourseCompletion, getLanguageCode, getB2BCourseList, getAssessmentDetails, getB2BSAT, getOfferbaner, getLernerView, getSatDetails, getRecomdedCourseList, getBundleCourses1, getAllFreeCourses, getAllcourseDetails, getDynamicCourseDetails, getUserOnBoardByUserId } from '../../../Redux/Action';

export default function useLoginFlow(resetPasswordMode) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { token } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect');
  const isMounted = useRef(true);
  const [forgetClick, setForgetClick] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [emailFrom, setEmailFrom] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgetloading, setForgetLoading] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [resendEmailLoading, setResendEmailLoading] = useState(false);
  const [reactivateLoading, setReactivateLoading] = useState(false);
  const [savedEmail, setSavedEmail] = useState('');
  const [savedPassword, setSavedPassword] = useState('');
  const [forgetEmail, setForgetEmail] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [confirmPasswordValue, setConfirmPasswordValue] = useState('');
  const [verificationEmail, setVerificationEmail] = useState('');
  const [disableEmail, setDisableEmail] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [verificationData, setVerificationData] = useState(false);
  const [tokenError, setTokenError] = useState('');
  const [passwordError, setPasswordError] = useState({ pasErr: '', conPassErr: '' });
  const [showPasswordLengthError, setShowPasswordLengthError] = useState(false);
  const [showPasswordMismatchError, setShowPasswordMismatchError] = useState(false);
  const [showEmailNotRegistered, setShowEmailNotRegistered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const [reactivateState, setReactivateState] = useState('default');
  const [userId, setUserId] = useState('');
  const [statusAlert, setStatusAlert] = useState(null);
  const [openSnackbarState, setOpenSnackbarState] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [branding, setBranding] = useState(getCachedBranding());
  const [timezone, setTimezone] = useState('');
  const [ipaddress, setIpAddress] = useState('');
  const [resultlocation, setResult] = useState({});
  const [locationpermission, setLocationpermission] = useState('blocked');
  const [showLearningJourney, setShowLearningJourney] = useState(false);
  const [pendingRetry, setPendingRetry] = useState(null);
  const email = searchParams.get('userId');
  const [emailError, setEmailError] = useState('');
  const [comingJourney, setComingJourney] = useState('normal');

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (redirectUrl) {
      localStorage.setItem('redirectAfterLogin', redirectUrl);
    }
    const token = Cookies.get('token');
    if (token && redirectUrl) {
      getLoginUserDetails();
    }
  }, []);

  useEffect(() => {
    if (resetPasswordMode === 'forgot') {
      setForgetClick(true);
      setSendEmail(false);
      setShowEmailVerification(false);
      setEmailFrom('');
    } else if (resetPasswordMode === 'sent') {
      setForgetClick(true);
      setSendEmail(true);
      setShowEmailVerification(false);
      setEmailFrom('');
    } else if (resetPasswordMode === 'verify') {
      /* handled by token validation effect below */
    } else {
      setForgetClick(false);
      setSendEmail(false);
      setShowEmailVerification(false);
      setEmailFrom('');
    }
  }, [resetPasswordMode]);

  useEffect(() => {
    const cached = getCachedBranding();
    if (cached) {
      setBranding(cached);
      return;
    }
    fetchBranding()
      .then((r) => {
        if (r && r.ok && r.data) {
          storeBranding(r.data);
          if (isMounted.current) {
            setBranding(r.data);
          }
        }
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    dispatch(getLanguageCode());
  }, []);

  useEffect(() => {
    if (location.state?.showEmailVerification) {
      setShowEmailVerification(true);
      setVerificationEmail(location.state.verificationEmail || '');
    }
  }, [location.state]);

  useEffect(() => {
    if (resetPasswordMode !== 'verify') return;

    if (!token) {
      setIsValid(false);
      setTokenError('No reset token provided');
      setVerifyLoader(false);
      return;
    }

    setVerifyLoader(true);
    loginServices
      .validateResetToken(token)
      .then((response) => {
        if (response.ok && response.data.valid) {
          setVerificationData(response.data.valid);
          setIsValid(true);
          setEmailFrom(true);
        } else {
          setIsValid(false);
          setTokenError(response.data?.error || 'Invalid reset link');
          setEmailFrom(true);
        }
      })
      .catch(() => {
        setIsValid(false);
        setTokenError('Failed to validate reset link');
        setEmailFrom(true);
      })
      .finally(() => setVerifyLoader(false));
  }, [resetPasswordMode, token]);

  useEffect(() => {
    if (localStorage.getItem('locationPermission') === 'blocked') return;
    if (resetPasswordMode === 'forgot' || resetPasswordMode === 'sent' || resetPasswordMode === 'verify') return;

    const parser = new UAParser();
    const ua = parser.getResult();
    setResult(ua);
    localStorage.setItem('ua', JSON.stringify(ua));

    fetch('https://api.ipify.org?format=json')
      .then((r) => r.json())
      .then((data) => {
        localStorage.setItem('ip', data.ip);
        if (isMounted.current) {
          setIpAddress(data.ip);
        }
        requestLocation();
      });
  }, []);

  const showSnackbar = (msg) => {
    setSnackbarTitle(msg);
    setOpenSnackbarState(true);
  };

  const getLocationCoords = () => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      fetch(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`
      )
        .then((r) => r.json())
        .then((data) => {
          const loc = `${data.city}, ${data.principalSubdivision}, ${data.countryName}`;
          setTimezone(loc);
          localStorage.setItem('location', loc);
        });
    });
  };

  const requestLocation = () => {
    if (!navigator.geolocation) return;

    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'granted') {
        getLocationCoords();
        return;
      }
      if (result.state === 'denied') return;

      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationpermission('allowed');
          getLocationCoords();
          localStorage.setItem('locationPermission', 'allowed');
        },
        (err) => {
          if (err.code === 1) {
            setLocationpermission('blocked');
            localStorage.setItem('locationPermission', 'blocked');
            localStorage.setItem('location', '');
          }
        }
      );
    });
  };

  // Shared by password login and Google login — same /authenticate endpoint,
  // same response shape, same status-code handling either way.
  const processLoginResult = async (response, email, retryFn) => {
    if (!response.ok) {
      setSavedEmail(email || '');

      const sid = response.data?.relatedStatusId;

      if (sid === 5) {
        setUserId(response.data.userId);
        setShowReactivateModal(true);
        setPendingRetry(() => retryFn);
        setLoading(false);
        return;
      }

      if (sid === 7 || sid === 8 || sid === 9) {
        setStatusAlert({ type: sid, email });
        setLoading(false);
        return;
      }

      if (sid === 11) {
        const emailToVerify = response.data.email || email;

        try {
          await loginServices.sendSignupOtp({ email: emailToVerify, firstName: '' });
        } catch (err) {
          console.log('Failed to send verification OTP:', err);
        }

        setLoading(false);
        navigate('/verify-otp', { state: { email: emailToVerify, firstName: '' } });
        return;
      }

      if (response.data?.message === 'You have not verified your email ID. Please verify before Login!') {
        try {
          await loginServices.sendSignupOtp({ email, firstName: '' });
        } catch (err) {
          console.log('Failed to send verification OTP:', err);
        }

        setLoading(false);
        navigate('/verify-otp', { state: { email, firstName: '' } });
        return;
      }

      if (response.data?.code === 'ORG_DEACTIVATED') {
        setStatusAlert({ type: 'ORG_DEACTIVATED' });
        setLoading(false);
        return;
      }
      if (response.data?.code === 'USER_SUSPENDED') {
        setStatusAlert({ type: 'USER_SUSPENDED' });
        setLoading(false);
        return;
      }
      if (response.data?.code === 'USER_DEACTIVATED') {
        setStatusAlert({ type: 'USER_DEACTIVATED' });
        setLoading(false);
        return;
      }

      if (response.data?.message) {
        // const msg =
        //   typeof response.data.message === 'object'
        //     ? response.data.message.password
        //     : response.data.message;
        // showSnackbar(msg);
        //   if (msg === 'Email address does not exist! Please Signup now.') {
        //     setEmailError(msg);
        //   }
        const message = response.data.message;

        const msg =
          typeof message === 'object' && message !== null
            ? message.password || message.emailAddress
            : message;

        showSnackbar(msg);

        if (message?.emailAddress) {
          setEmailError(message.emailAddress);
        } else if (msg === 'Email address does not exist! Please Signup now.') {
          setEmailError(msg);
        }
      } else {
        showSnackbar('Something went wrong, Please try again.');
      }

      posthog.capture('login_failed', {
        reason: response.data?.message || response.data?.code || 'unknown',
      });

      localStorage.removeItem('redirectAfterLogin');
      setLoading(false);
      return;
    }
    apiClient.setHeader('Authorization', `BEARER ${response.data.token}`);
    Cookies.set('token', response.data.token);
    Cookies.set('refreshToken', response.data.refreshToken);
    Cookies.set('isLogIn', true);
    const decoded = jwtdecode(response.data.token);
    Cookies.set('tokenExpireTime', decoded.exp);

    const res = response.data;
    const isFirstTimeUser = res?.related_role_id === 5 && (res?.lastLoginDateTime === null || res?.hasLearningTypePreference === false);
    if (isFirstTimeUser) {
      setShowLearningJourney(true);
      setLoading(false);
      return;
    }
    await getLoginUserDetails();
    setLoading(false);
  };

  const handleSubmitForm = async (values) => {
    const parser = new UAParser();
    const uaNow = parser.getResult();
    setLoading(true);
    setStatusAlert(null);
    setEmailError('');
    setSavedPassword(values.password);
    setComingJourney('normal');
    const data = {
      emailAddress: values.email,
      password: values.password || '',
      browser: uaNow.browser?.name || resultlocation.browser?.name || 'Unknown',
      browserVersion: uaNow.browser?.version || resultlocation.browser?.version || '',
      os: uaNow.os?.name || resultlocation.os?.name || 'Unknown',
      osVersion: uaNow.os?.version || resultlocation.os?.version || '',
      deviceType: uaNow.device?.type || resultlocation.device?.type || 'desktop',
      ip: ipaddress,
      location: timezone,
      locationPermission: locationpermission,
      schema: localStorage.getItem('tenant_kss') || 'public',
    };

    const response = await loginServices.userLogin(data);
    await processLoginResult(response, values.email, () => handleSubmitForm(values));
  };

  // Google Sign-In — reuses the same POST /authenticate call and the same
  // 'googleId' in body branch the backend already had scaffolded, so it goes
  // through identical status/inactive/suspended handling as password login.
  const handleGoogleLogin = async (credentialResponse) => {
    if (!credentialResponse?.credential) return;
    setLoading(true);
    setStatusAlert(null);
    setComingJourney('google');

    let email = '';
    try {
      email = jwtdecode(credentialResponse.credential)?.email || '';
    } catch (err) {
      console.log('Failed to decode Google credential:', err);
    }

    const data = {
      googleId: credentialResponse.credential,
      schema: localStorage.getItem('tenant_kss') || 'public',
    };

    const response = await loginServices.userLogin(data);
    await processLoginResult(response, email, () => handleGoogleLogin(credentialResponse));
  };

  const handleGoogleLoginError = () => {
    showSnackbar('Google sign-in failed. Please try again.');
  };

  const handleResetPasswordClick = async (values) => {
    setForgetLoading(true);
    try {
      const res = await loginServices.forgetPassword({ email: values.email });
      if (res.ok) {
        setForgetEmail(res.data?.emailId);
        setSendEmail(true);
        posthog.capture('password_reset_requested');
        navigate('/reset-password/sent', { replace: true });
      } else if (res.data?.code === 'USER_SUSPENDED') {
        setStatusAlert({ type: 'USER_SUSPENDED' });
      } else if (res.data?.code === 'ORG_DEACTIVATED') {
        setStatusAlert({ type: 'ORG_DEACTIVATED' });
      } else if (res.data?.message === 'Your email is not registered on keySkillset yet. Please register to continue!') {
        setShowEmailNotRegistered(true);
      } else if (res.data?.code === 'USER_DEACTIVATED') {
        setStatusAlert({ type: 'USER_DEACTIVATED', message: res.data.message });
      } else {
        showSnackbar(res.data?.message || 'Failed to send mail.');
      }
    } catch (err) {
      console.log(err);
    }
    setForgetLoading(false);
  };

  const handleChangePassword = async () => {
    const valid = validatePasswords();
    if (!valid) return;

    setChangePasswordLoading(true);
    try {
      const res = await loginServices.PasswordChange({ password: passwordValue, token });
      if (res.ok) {
        setIsModalOpen(true);
      } else {
        showSnackbar(res.data?.error || 'Failed to reset password');
      }
    } catch (err) {
      showSnackbar('Something went wrong. Please try again.');
    }
    setChangePasswordLoading(false);
  };

  const handleReactivate = async () => {
    setReactivateState('reactivating');
    setReactivateLoading(true);
    const res = await loginServices.reactivateAccount(userId);
    if (res.ok) {
      setReactivateState('success');
      setShowReactivateModal(false);
      setTimeout(() => {
        if (pendingRetry) {
          pendingRetry();
        } else {
          handleSubmitForm({ email: savedEmail, password: savedPassword });
        }
      }, 1500);
    } else {
      setReactivateState('default');
    }
    setReactivateLoading(false);
  };

  const handleKeepWaiting = () => {
    setReactivateState('waiting');
    setTimeout(() => {
      setShowReactivateModal(false);
      setReactivateState('default');
    }, 1500);
  };

  const handleResendEmail = async () => {
    setResendEmailLoading(true);
    try {
      await loginServices.sendEmail({ email: verificationEmail, firstName: '' });
      setTimeout(() => {
        setResendEmailLoading(false);
        showSnackbar('Verification email has been sent. Please check now!');
      }, 3000);
    } catch (err) {
      setResendEmailLoading(false);
      console.log(err);
    }
  };

  const forgetPassword = () => {
    if (email) setSavedEmail(email);
    setStatusAlert(null);
    setForgetClick(true);
    navigate('/reset-password', { replace: true });
  };

  const backToLogin = () => {
    const emailToPreFill = verificationEmail || savedEmail;
    setSendEmail(false);
    setForgetClick(false);
    setShowEmailVerification(false);
    setVerificationEmail('');
    setEmailFrom('');
    setLoading(false);
    setStatusAlert(null);
    setIsValid(true);
    setShowEmailNotRegistered(false);
    setShowPasswordLengthError(false);
    setShowPasswordMismatchError(false);
    setSavedEmail(emailToPreFill);
    navigate('/login', { replace: true });
  };

  const closeSuccessModal = () => {
    setIsModalOpen(false);
    setForgetClick(false);
    setEmailFrom('');
    navigate('/login');
  };

  const validatePasswords = () => {
    setShowPasswordLengthError(false);
    setShowPasswordMismatchError(false);
    setPasswordError({ pasErr: '', conPassErr: '' });

    if (!passwordValue && !confirmPasswordValue) {
      setPasswordError({ pasErr: 'New password is required', conPassErr: 'Confirm password is required' });
      return false;
    }
    if (!passwordValue) {
      setPasswordError({ pasErr: 'New password is required' });
      return false;
    }
    if (passwordValue.length < 4) {
      setShowPasswordLengthError(true);
      return false;
    }
    if (!confirmPasswordValue) {
      setPasswordError({ conPassErr: 'Confirm password is required' });
      return false;
    }
    if (passwordValue !== confirmPasswordValue) {
      setShowPasswordMismatchError(true);
      return false;
    }
    return true;
  };

  const getCourserList = async () => {
    try {
      const response = await courseApi.getCourseList();
      if (response.ok) dispatch(setSubscribedCourses(response.data));
    } catch (err) {
      console.log(err);
    }
  };

  const postTrialCourseDetails = async (planId) => {
    try {
      const res = await trialAndStripeSubscriptionService.postTrialCourseEnrollmentDetails(
        JSON.stringify({ planId, enrollmentType: 'trial' })
      );
      if (res.ok) {
        await getCourserList();
        posthog.capture('trial_enrolled', { plan_id: planId });
        dispatch(openSnackbar('Trial Course Subscribed Successfully.'));
      } else {
        dispatch(openSnackbar(res.data?.message || 'Failed to Subscribe Trial Course, Please try again.'));
      }
      navigate('/auth/my-courses');
    } catch (err) {
      console.log(err);
    }
  };

  const postSubscribeDetails = async (planId) => {
    dispatch(setOpenSubscriptionModalDetails(location?.state?.openSubscriptionModalDetails));
    dispatch(openSubscriptionModal(planId));
    navigate('/auth/subscribe', { replace: true });
  };

  // The ?redirect= deep links below all land on /auth/* screens (subscribe,
  // assessment, course-details), which only exist in the learner route trees.
  // This used to be gated by naming the three staff roles to exclude - so every
  // role added later (MARKETING_USER, CONTENT_WRITER) fell through into the
  // learner branch and was pushed to /auth/subscribe. That route does not exist
  // in the admin tree, so it fell back to /login, which still carried ?redirect=
  // and re-ran this whole flow: a redirect loop firing thousands of requests.
  // Gate on the role's layout instead, so new roles are correct by default.
  const LEARNER_LAYOUTS = ['USER', 'DIRECT_USER'];
  const LEGACY_LEARNER_ROLES = ['USER_DTC', 'AUTH_USER'];
  const isLearnerLayout = (layout, role) =>
    (layout ? LEARNER_LAYOUTS.includes(layout) : LEGACY_LEARNER_ROLES.includes(role));

  const navigateAfterLogin = (defaultRoute, role, layout) => {
    const redirectUrl = localStorage.getItem('redirectAfterLogin');

    if (redirectUrl && isLearnerLayout(layout, role)) {
      localStorage.removeItem('redirectAfterLogin');

      if (redirectUrl === 'Assessments') {
        dispatch(ComingFrom('Assessments'));
        navigate('/auth/subscribe', { replace: true });
        return;
      }

      if (redirectUrl === 'Courses') {
        dispatch(ComingFrom('Courses'));
        navigate('/auth/subscribe', { replace: true });
        return;
      }

      if (redirectUrl === 'Dashboard') {
        dispatch(ComingFrom('Dashboard'));
        navigate('/auth/subscribe', { replace: true });
        return;
      }

      if (redirectUrl.startsWith('/auth/assessment/') && role === 'USER_DTC') {
        setTimeout(() => {
          navigate(redirectUrl, { replace: true });
        }, 0);
        return;
      }

      if (redirectUrl.startsWith('/auth/course-details/') && role === 'USER_DTC') {
        setTimeout(() => {
          navigate(redirectUrl, { replace: true });
        }, 0);
        return;
      }
    } else if (redirectUrl) {
      // Not a learner layout: the deep link is meaningless here and would other-
      // wise be replayed on the next login. Drop it, and strip the ?redirect=
      // param so reloading this URL cannot start the loop again.
      localStorage.removeItem('redirectAfterLogin');
      if (searchParams.get('redirect')) {
        const next = new URLSearchParams(searchParams);
        next.delete('redirect');
        setSearchParams(next, { replace: true });
      }
    }

    navigate(defaultRoute, { replace: true });
  };

  const getLoginUserDetails = async () => {
    try {
      const response3 = await loginServices.getUserInfo();
      if (!response3.ok || !response3.data?.role) return;

      dispatch(loginSuccess(response3.data));
      dispatch(getAssessmentDetails());

      identifyPosthogUser(response3.data);
      posthog.capture('login_succeeded');

      if (response3.data.role === 'CONTENT_WRITER') {
        dispatch(languagecodevalue('en'));
        localStorage.setItem('selectedToggle', 'paid');
        navigateAfterLogin(response3.data.defaultRoute || '/app/dashboard', response3.data.role, response3.data.layout);
        return;
      }

      if (response3.data.role === 'AUTH_USER') {
        dispatch(languagecodevalue('en'));
        dispatch(getB2BCourseList(response3.data.id, 'paid'));
        dispatch(getB2BSAT(response3.data.id));
        localStorage.setItem('selectedToggle', 'paid');
        navigateAfterLogin(response3.data.defaultRoute || '/app/course', response3.data.role, response3.data.layout);
        return;
      }

      if (response3.data.role === 'USER_DTC') {
        setLoading(true);
        await Promise.all([
          getCourserList(),

          dispatch(getUserOnBoardByUserId(response3.data.id)),
          dispatch(getCourseCompletion(response3.data.id)),
          dispatch(getAllcourseDetails('en')),
          dispatch(getAllFreeCourses('en', response3.data.id)),
          dispatch(getDynamicCourseDetails('en', response3.data.id)),

          dispatch(getSatDetails(response3.data.id)),
        ]);

        if (location?.state?.from === 'trialButton') {
          await postTrialCourseDetails(location?.state?.planId);
        } else if (location?.state?.from === 'subscribeButton') {
          await postSubscribeDetails(location?.state?.planId);
        } else {
          navigateAfterLogin('/auth/subscribe', response3.data.role, response3.data.layout);
        }

        if (isMounted.current) {
          setLoading(false);
        }

        Promise.all([
          dispatch(getRecomdedCourseList(response3.data.id, 'en')),
          dispatch(getOfferbaner()),
          dispatch(getBundleCourses1(1, 'en')),
          dispatch(getLernerView('en')),
        ]).catch((error) => {
          console.error('Error loading secondary course data:', error);
        });

        return;
      }

      if (response3.data.role === 'CLIENT_ADMIN') {
        navigateAfterLogin(response3.data.defaultRoute || '/app/dashboard', response3.data.role, response3.data.layout);
        return;
      }

      if (response3.data.role === 'MANAGER') {
        navigateAfterLogin(response3.data.defaultRoute || '/app/dashboard', response3.data.role, response3.data.layout);
        return;
      }

      // Roles that need no bespoke pre-loading (MARKETING_USER and any future role)
      // land on role_lk.default_route, falling back to the previous hardcoded target.
      dispatch(languagecodevalue('en'));
      navigateAfterLogin(response3.data.defaultRoute || '/app/dashboard', response3.data.role, response3.data.layout);
    } catch (error) {
      console.log('Login error:', error);
      setLoading(false);
    }
  };

  return {
    forgetClick,
    sendEmail,
    showEmailVerification,
    emailFrom,
    setSendEmail,
    loading,
    forgetloading,
    changePasswordLoading,
    verifyLoader,
    resendEmailLoading,
    reactivateLoading,
    savedEmail,
    savedPassword,
    forgetEmail,
    passwordValue,
    setPasswordValue,
    confirmPasswordValue,
    setConfirmPasswordValue,
    verificationEmail,
    disableEmail,
    setDisableEmail,
    isValid,
    verificationData,
    tokenError,
    passwordError,
    setPasswordError,
    showPasswordLengthError,
    setShowPasswordLengthError,
    showPasswordMismatchError,
    setShowPasswordMismatchError,
    showEmailNotRegistered,
    setShowEmailNotRegistered,
    isModalOpen,
    showReactivateModal,
    reactivateState,
    setReactivateState,
    statusAlert,
    setStatusAlert,
    openSnackbarState,
    snackbarTitle,
    setOpenSnackbarState,
    branding,
    handleSubmitForm,
    handleGoogleLogin,
    handleGoogleLoginError,
    handleResetPasswordClick,
    handleChangePassword,
    handleReactivate,
    handleKeepWaiting,
    handleResendEmail,
    forgetPassword,
    backToLogin,
    closeSuccessModal,
    showLearningJourney,
    setShowLearningJourney,
    comingJourney,
    getLoginUserDetails,
    emailError,
    setEmailError,
  };
}